/* eslint-disable @typescript-eslint/explicit-function-return-type */
import styled from 'styled-components';
import {
  Button,
  Container as RawContainer,
  size,
  typography,
  mediaQueries,
  colors,
} from '@everlywell/leaves';

export const Section = styled.section.attrs(props => ({
  backgroundColor: props.backgroundColor,
}))`
  background-color: none;

  ${mediaQueries.forTabletHorizontalUp} {
    background-color: ${props =>
      props.backgroundColor ? props.backgroundColor : `${colors.white}`};
  }
`;

export const PrimaryContainer = styled(RawContainer)``;

export const HeadlineAndDescription = styled.div``;

export const Headline = styled.h1`
  ${typography.h3Text};

  ${mediaQueries.forTabletHorizontalUp} {
    ${typography.h2Text};
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: start;
  align-items: center;
  padding-top: ${size.lg}px;

  ${mediaQueries.forTabletHorizontalUp} {
    flex-direction: row;
    justify-content: space-between;
    min-height: 352px;
    align-items: center;
  }
`;

export const Description = styled.div`
  display: block;
  ${typography.bodyTextSmall}
  padding-top: ${size.xs1}px;

  ${mediaQueries.forTabletHorizontalUp} {
    ${typography.bodyText}
  }
`;

export const MainCTA = styled(Button).attrs(props => ({
  onClick: props.onClick,
}))`
  margin-top: ${size.lg}px;
`;

export const InfoBlock = styled.div`
  max-width: 164px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const Heading = styled.p`
  ${typography.subtitle}
  text-align: center;
  margin-top: ${size.sm}px;
  max-width: 144px;
`;

export const ImgContainer = styled.div`
  position: relative;
`;

export const NumberTag = styled.div`
  ${typography.buttonText}
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${colors.green5};
  border-radius: 50%;
  color: ${colors.white};
  position: absolute;
  height: 45px;
  width: 45px;
  transform: translate(-50%, 50%);
  bottom: ${size.lg}px;
  left: 50%;
`;

export const InfoBlockContainer = styled.div`
  display: none;
  ${mediaQueries.forTabletHorizontalUp} {
    display: flex;
    justify-content: space-around;
    align-items: flex-end;
  }

  ${mediaQueries.forDesktopUp} {
    justify-content: space-between;
    padding-left: 64px;
  }
`;
